import { render, staticRenderFns } from "./AddAppointmentModal.vue?vue&type=template&id=b8f8584c&"
import script from "./AddAppointmentModal.vue?vue&type=script&lang=js&"
export * from "./AddAppointmentModal.vue?vue&type=script&lang=js&"
import style0 from "./AddAppointmentModal.vue?vue&type=style&index=0&id=b8f8584c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports